module.exports = __webpack_public_path__ + "static/img/spankwire.6b6cb37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/spankwire.png
// module id = N26K
// module chunks = 0